import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CommoditiesFormFields } from "web_myplann/Portfolio/Forms/CommoditiesForm/CommoditiesFormFields";
import { useCreateCommoditiesForm } from "web_myplann/Portfolio/Forms/CommoditiesForm/useCreateCommoditiesForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateCommoditiesForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateCommoditiesForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<CommoditiesFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
